const Year = {

    // FIELDS
    "start_date": "Petsa ng Pagsisimula",
    "end_date": "Petsa ng Pagtatapos",
    "fy": "Taong Pinansyal",
    "fy_short_name": "Maikling Pangalan ng Taong Pinansyal",
    "status": "Katayuan",
    "search": "Maghanap",

    // PAGE HEADER
    "year": "Taon",

    // ERROR
    "error_start_date": "Piliin ang Petsa ng Pagsisimula",
    "error_end_date": "Piliin ang Petsa ng Pagtatapos",
    "error_fy": "Ilagay ang Taong Pinansyal",
    "error_fy_short_name": "Ilagay ang Maikling Pangalan ng Taong Pinansyal",
    "error_status": "Piliin ang Katayuan",

    // TABLE HEADER
    "table_start_date": "PETSA NG PAGSISIMULA",
    "table_end_date": "PETSA NG PAGTATAPOS",
    "table_fy": "TAONG PINANSYAL",
    "table_fy_short_name": "MAIKLING PANGALAN NG TAONG PINANSYAL",
    "table_status": "KATAYUAN",

}

export default Year;